export default __webpack_public_path__ + "static/media/corner-5.d84c5028.png";